import React, { FC } from 'react';

const RemovalOfResidues: FC = () => {
  return (
    <div>
      <ul className="indent-6">
        <li>
          <span className="before:content-['•'] before:mr-0.5 before:text-astronautBlue-500">
            NEW – нове бронювання
          </span>
        </li>
        <li>
          <span className="before:content-['•'] before:mr-0.5 before:text-astronautBlue-500">
            RECEIVED – бронювання отримано аптекою
          </span>
        </li>
        <li>
          <span className="before:content-['•'] before:mr-0.5 before:text-astronautBlue-500">
            APPROVED – бронювання підтверджено
          </span>
        </li>
        <li>
          <span className="before:content-['•'] before:mr-0.5 before:text-astronautBlue-500">
            CANCELED - бронювання скасовано
          </span>
        </li>
        <li>
          <span className="before:content-['•'] before:mr-0.5 before:text-astronautBlue-500">
            CANCELED_BY_LIKIE - бронювання скасовано через Likie
          </span>
        </li>
        <li>
          <span className="before:content-['•'] before:mr-0.5 before:text-astronautBlue-500">
            CANCEL_APPROVED - скасування підтверджено аптекою
          </span>
        </li>
        <li>
          <span className="before:content-['•'] before:mr-0.5 before:text-astronautBlue-500">
            PAID - оплачено
          </span>
        </li>
        <li>
          <span className="before:content-['•'] before:mr-0.5 before:text-astronautBlue-500">
            DELIVERED - доставлено
          </span>
        </li>
      </ul>
    </div>
  );
};

export default RemovalOfResidues;
